/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LocalisationDto } from '../../models/localisation-dto';

export interface GetLocalisationsBySite$Params {
  id_site: string;
}

export function getLocalisationsBySite(
  http: HttpClient,
  rootUrl: string,
  params: GetLocalisationsBySite$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<Array<LocalisationDto>>> {
  const rb = new RequestBuilder(rootUrl, getLocalisationsBySite.PATH, 'get');
  if (params) {
    rb.query('id_site', params.id_site, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<LocalisationDto>>;
    })
  );
}

getLocalisationsBySite.PATH = '/v1/localisations';
